// extracted by mini-css-extract-plugin
export default {"wrapper":"_e5a00d0","info":"_e3a13c2d","subtitle":"_6e957007","title":"_ee50c583","description":"_e1034865","videoWrapper":"_b71e1521","video":"_c7579b32"};